import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Button, App } from 'antd';
import { eventBus } from '@/utils/eventBus';
import { getUserBrowserRecordList,saveUserBrowserRecord } from '@/api/products';
import YourTownloopProductList from '../../components/YourTownloopProductList/YourTownloopProductList';
import styles from './BrowsingHistory.module.scss';
import iocn2 from '@/assets/images/组件 2 – 2@2x.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BrowsingHistory: React.FC = () => {
  const { message } = App.useApp();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state) => state.searchBar.yourTownloopSearchValue);



  //浏览历史列表
  const [historyList, setHistoryList] = useState<any[]>([

  ]);


  //消息列表关键字搜索
  const [searchValue, setSearchValue] = useState<string>('');

  const searchAction = () => {
    console.log('searchValue', searchValue);
    getUserBrowserRecordListFn(searchValue);
  }

  // 搜索消息列表处理键盘回车事件
  const searchHandleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchAction();
    }
  }

  //获取商品id
  const getId = (id: string) => {
    navigate(`/ProductDetail/${id}`);
  }

  const getUserBrowserRecordListFn = (keyword: string) => {
    getUserBrowserRecordList({ keyword: keyword }).then((res) => {
      if (res.code === 200) {
        setHistoryList(res.data);
      }
    });
  }

  const batchManagement = () => {
    console.log('batchManagement');
    saveUserBrowserRecord({
      is_delete: true,
    }).then((res) => {
      if (res.code === 200) {
        getUserBrowserRecordListFn('');
      }
    });
  }

  //mounted 和unmounted
  useEffect(() => {

    getUserBrowserRecordListFn('');

    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, []);

  //yourTownloopSearchValue关键字的监听
  useEffect(() => {
    console.log('BrowsingHistory组件yourTownloopSearchValue', yourTownloopSearchValue);

  }, [yourTownloopSearchValue])

  return (
    <div className={styles['history-box']}>
      <div className={styles['search-btn-box']}>
        <div className={styles['sidebar-search']}>
          <input
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={searchHandleKeyDown}
            type="text"
            placeholder={t("BrowsingHistory.PleaseSearchForContacts")}
          />
          <img src={iocn2} alt="" style={{ cursor: 'pointer' }} onClick={searchAction} />
        </div>
        <Button className={styles['search-btn']} onClick={batchManagement}>{t("BrowsingHistory.ClearRecords")}</Button>

      </div>

      <div className={styles['list']}>
        {
          historyList.map((item, index) => (
            <div className={styles['list-item']} key={index}>
              <div className={styles['time-box']}>
                <div className={styles['time-left']}>
                  <span className={styles['time-left-title1']}>{item.date}</span>
                  <span className={styles['time-left-title2']}>({item.records.length})</span>
                </div>
              </div>
              <YourTownloopProductList
                products={item.records}
                getId={getId}
              ></YourTownloopProductList>
            </div>
          ))
        }
      </div>





    </div>
  );
};

export default BrowsingHistory; 